import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PowerpointShortcutSvg = function PowerpointShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.488 15h.684v-2.358h1.341c1.386 0 2.309-.756 2.309-2.048 0-1.363-1.049-2.101-2.453-2.101H10.06v5.499q.245.488.428 1.008m-1.89-3.12c.27-.333.418-.766.418-1.286 0-1.363-1.048-2.101-2.452-2.101H4.255v.792a9 9 0 0 1 1.103.362v-.29h1.291c.761 0 1.328.427 1.328 1.174q-.002.347-.148.612.406.345.77.736m2.565-.116h1.323c.76 0 1.296-.5 1.296-1.233 0-.747-.567-1.174-1.328-1.174h-1.291zm7.227-2.286V15h-1.098V9.478h-2.025v-.985h5.076v.985z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var PowerpointShortcut = function PowerpointShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PowerpointShortcutSvg
  }));
};